module.exports = __webpack_public_path__ + "media/notification.36ff1b07.mp3";